interface IExpandableRowProps {
    children: React.ReactNode;
    colSpan?: number;
    columnPlaceholderCount?: number;
    contentMarginLeft?: string;
    customDivStyles?: React.CSSProperties;
    customTdStyles?: React.CSSProperties;
    customTrStyles?: React.CSSProperties;
    isExpanded: boolean;
}

function ExpandableRow(props: IExpandableRowProps) {
    const placeholderCells = Array.from(
        { length: props.columnPlaceholderCount ?? 0 },
        (_, index) => index
    );

    if (!props.isExpanded) {
        return null;
    }

    return (
        <tr style={{ ...props.customTrStyles }}>
            <td colSpan={props.colSpan} style={{ ...props.customTdStyles }}>
                <div style={{ ...props.customDivStyles }}>
                    <div
                        style={{
                            marginLeft: props.contentMarginLeft,
                            visibility: props.isExpanded ? 'visible' : 'collapse',
                            height: props.isExpanded ? 'auto' : 0,
                        }}
                    >
                        <div
                            style={{
                                paddingBottom: '1em',
                            }}
                        >
                            {props.children}
                        </div>
                    </div>
                </div>
            </td>
            {placeholderCells.map((_, index) => (
                <td key={index} />
            ))}
        </tr>
    );
}

export default ExpandableRow;
